import * as yup from 'yup';
import { useTranslations } from 'hooks/useTranslations';
import { countEditorCharacters } from 'components/organisms/HtmlSlate';

const useFormSchema = () => {
  const { t } = useTranslations();
  const schema = yup.object({
    name: yup
      .string()
      .required(t('general.field.validation.required'))
      .max(250, t('general.field.validation.maxCharacters').replace('{0}', '250'))
      .trim(),
    description: yup
      .string()
      .required(t('general.field.validation.required'))
      .test(
        'editor-required',
        t('general.field.validation.required'),
        (value) => countEditorCharacters(value) > 0,
      )
      .test(
        'editor-validation',
        t('general.field.validation.maxCharacters').replace('{0}', '10000'),
        (value) => countEditorCharacters(value) <= 10000,
      )
      .trim(),
  });

  return { schema };
};

export { useFormSchema };
